import React from "react";
import { TenantModalContainer } from "./styles";
import CustomModal from "../AntModal/CustomModal"; // Importando o CustomModal
import { Select } from "antd"; // Importando o Select do Ant Design
import { OptionValue } from "../../dto/OptionValue";
import TenantProvider from "../../provider/TenantProvider";
import DefaultButton from "../DefaultButton";
import UserProvider from "../../provider/UserProvider";
import AuthProvider from "../../provider/AuthProvider";
import { useNavigate } from "react-router-dom";
import { useSelection } from "../../context/selection/selectionProvider";

function TenantModal(): JSX.Element {
	const [loading, setLoading] = React.useState(false);
	const [tenantOptions, setTenantOptions] = React.useState(
		[] as Array<OptionValue>
	);
	const [selectedTenantOption, setSelectedTenantOption] = React.useState(
		{} as { value: string; label: string }
	);
	const [tenantValue, setTenantValue] = React.useState(
		selectedTenantOption.label || ""
	);

	const { isMultiTenantOpen, setIsMultiTenantOpen, refreshPermissions} = useSelection();

	const navigate = useNavigate();
	const tenantProvider = new TenantProvider();
	const authProvider = new AuthProvider();

	async function requireTenantOptions() {
		try {
			const data = await tenantProvider.getFromLoggedUser();
			if (!data) return [] as Array<OptionValue>;

			setTenantOptions(data);
			return data;
		} catch (error) {
			console.error("Erro ao buscar tenants:", error);
			return [] as Array<OptionValue>;
		}
	}

	function setSelectsDefaults(tenants: OptionValue[]) {
		const selectedTenant = tenants.find(
			(tenant) => tenant.label === window.localStorage.getItem("tenantName")
		);

		setSelectedTenantOption(
			selectedTenant || ({} as { value: string; label: string })
		);
	}

	async function onInit() {
		const tenants = await requireTenantOptions();
		setSelectsDefaults(tenants);
	}

	React.useEffect(() => {
		onInit();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	async function handleLogout() {
		try {
			await authProvider.logout();
			navigate("/entrar");
		} catch (error) {
			console.error("Erro ao fazer logout:", error);
		}
	}

	function handleVoltarParaLogin() {
		handleLogout();
		setTimeout(() => setIsMultiTenantOpen(false), 1000);
	}

	async function handleSubmit() {
		setLoading(true);
		try {
			const response = await authProvider.selectTenant(
				selectedTenantOption.value
			);
			if (response) {
				await refreshPermissions();
				setIsMultiTenantOpen(false);
				window.location.reload();
			}
		} catch (error) {
			console.error("Erro ao selecionar tenant:", error);
		}
		setLoading(false);
	}

	return (
			<CustomModal
			title=""
			visible={isMultiTenantOpen}
			onCancel={handleVoltarParaLogin}
			onConfirm={handleSubmit}
			showSuccess={false}
			showWarning={false}
			cancelText="Voltar para o login"
			confirmText="Selecionar"
			footer={false}
			width={600}
		>
			<TenantModalContainer onSubmit={handleSubmit}>
				<h2 style={{ textAlign: "center", fontSize: "1.4em" }}>Você está cadastrado em mais de um ambiente do IdeiaX</h2>
				<h3 style={{ textAlign: "center", fontSize: "1.2em" }}>
					Escolha o ambiente que deseja acessar:
				</h3>
				<Select
					style={{ width: "100%", marginTop: 25 }}
					value={selectedTenantOption.value || undefined}
					onChange={(value, option) =>
						setSelectedTenantOption({
							value,
							label: (option as { label: string }).label,
						})
					}
					options={tenantOptions.map((tenant) => ({
						value: tenant.value,
						label: tenant.label,
					}))}
					showSearch
					placeholder="Selecione um ambiente"
					filterOption={(input, option) =>
						(option as { label: string }).label
							.toLowerCase()
							.includes(input.toLowerCase())
					}
				/>

			</TenantModalContainer>
		</CustomModal>
	);
}

export default TenantModal;
